import { useEffect, useState } from "react"

import { DefaultTooltip } from "twyne-new.ui"

import Popover from "./Popover"

const Size = ({ config, onSizeChange }) => <>
  <div className='w-full h-full twy-bg-base-accent border twy-border-base-accent flex items-center justify-center twy-text-base-accent text-[15px]'>
    <div className='flex items-center w-full h-full'>
      <SizeItem config={config} onSizeChange={onSizeChange} type='width' />
      <div className='font-bold text-base twy-text-base w-[10%] flex justify-center'>x</div>
      <SizeItem config={config} onSizeChange={onSizeChange} type='height' />
    </div>
  </div>
</>

const SizeItem = ({ config, onSizeChange, type }) => {
  const [configType, setConfigType] = useState()

  useEffect(() => {
    const newConfigType = config[type]
    if (!newConfigType.value && !newConfigType.unit) {
      newConfigType.unit = 'px'
    }

    setConfigType(newConfigType)
  }, [config, type])

  if (!configType) {
    return null
  }

  return <>
    <Popover onChange={({ value, unit, predefined }) => onSizeChange({ value, unit, predefined, type })} config={config[type]} size type={type}>
      <div className='mx-1 flex items-center w-[45%] py-1 rounded-xs cursor-pointer justify-center twy-subtle-neutral-hover hover:twy-text-base-accent'>
        <DefaultTooltip content={type}>
          <span className='text-base'>{configType.value || '-'}</span>
          {!configType.predefined && <span className='text-sm opacity-50'>{configType.value ? configType.unit : ''}</span>}
        </DefaultTooltip>
      </div>
    </Popover>
  </>
}

export default Size
